import React from 'react'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Confirmation from '../Confirmation'
import Input from '../Input'
import * as TableProps from './Table.propTypes'

function ColumnSelector(props) {
    const { children, columns, onChange, selectedColumns, t } = props

    const colValues = columns
        .filter((col) => {
            if (col && typeof col === 'object') {
                const { selectable } = col
                return selectable !== 'mandatory'
            }

            return true
        })
        .map((col) => {
            if (col && typeof col === 'object') {
                const { key, name, label, field } = col
                return {
                    name: name || label || field,
                    value: key,
                }
            }

            return col
        })

    const renderBody = () => {
        return <Input column name="countries" type="multiple" onChange={onChange} size="md" value={selectedColumns} values={colValues} />
    }

    return (
        <Confirmation confirmation={renderBody()} header={t('table-columns')} onConfirm={() => null} ok={t('ok')}>
            {children}
        </Confirmation>
    )
}

ColumnSelector.propTypes = {
    children: PropTypes.node.isRequired,
    columns: PropTypes.arrayOf(TableProps.displayItem),
    onChange: PropTypes.func,
    selectedColumns: PropTypes.arrayOf(PropTypes.string),
    t: PropTypes.func.isRequired,
}

ColumnSelector.defaultProps = {
    columns: [],
    onChange: () => null,
    selectedColumns: [],
}

export default withTranslation()(ColumnSelector)
